import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  id?: string;
  value: string;
  onChange: (v: string) => void;
  autoComplete?: string;
  invalid?: boolean;
  ariaLabelToggle?: string;
}

export default function PasswordField({
  id,
  value,
  onChange,
  autoComplete = 'current-password',
  invalid = false,
  ariaLabelToggle,
}: Props) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        autoComplete={autoComplete}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full px-3 py-2 pe-10 bg-paper border-2 ${invalid ? 'border-red-600' : 'border-ink'} rounded-btn-sm text-sm`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? t('auth.hidePassword') : (ariaLabelToggle ?? t('auth.showPassword'))}
        aria-pressed={visible}
        tabIndex={-1}
        className="absolute end-1 top-1/2 -translate-y-1/2 inline-flex w-8 h-8 items-center justify-center bg-transparent border-0 p-0 text-ink/60 cursor-pointer hover:text-ink"
      >
        {visible ? (
          <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 3l18 18" />
            <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
            <path d="M9.9 5.1A10.5 10.5 0 0 1 12 5c5 0 9 4 10 7-0.3 1-1.1 2.5-2.4 3.9M6.6 6.6C4.5 8.1 3.3 10.1 2 12c1 3 5 7 10 7 1.7 0 3.3-.5 4.6-1.2" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
}
